import { Component, OnInit } from '@angular/core';

import { CookieService } from 'src/app/core/services/cookie.service';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';
import { ModalPopupService } from 'src/app/shared/services/modal-popup.service';
import { CookieKey } from 'src/app/shared/constants/config.constant';
import { CommonApiService } from 'src/app/shared/services/common-api.service';
import { Store } from 'src/app/model/store.model';

@Component({
  selector: 'app-age-verification-dialog',
  templateUrl: 'age-verification-dialog.component.html',
  styleUrls: ['age-verification-dialog.component.scss']
})
export class AgeVerificationDialogComponent implements OnInit {
  companyLogo: string;
  CompanyName: string;
  isConfirm: boolean;
  isLoading: boolean;
  stores: Store[] = [];
  selectedStore: Store;

  constructor(
    private modalPopupService: ModalPopupService,
    public tokenManagerService: TokenManagerService,
    private cookieService: CookieService,
    private commonApiService: CommonApiService
  ) {
    this.isConfirm = true;
    this.selectedStore = {
      StoreId: this.tokenManagerService.appConfiguration.StoreId,
      StoreName: this.tokenManagerService.appConfiguration.StoreName
    }
  }

  ngOnInit(): void {
    this.companyLogo = this.tokenManagerService.appConfiguration.CompanyLogo;
    this.CompanyName = this.tokenManagerService.appConfiguration.CompanyName;
    this.getStores();
  }

  close(): void {
    this.modalPopupService.hideModal();
  }

  confirm(isConfirm: boolean): void {
    this.isConfirm = isConfirm;
    this.updateAgeVerification();
  }

  updateAgeVerification(): void {
    this.isLoading = true;
    this.commonApiService.updateAgeVerification(this.isConfirm).subscribe(
      () => {
        this.isLoading = false;
        this.cookieService.setCookie(CookieKey.AgrVerification, this.isConfirm.toString());
        if (this.isConfirm) {
          location.href = `?id=${this.selectedStore.StoreId}`;
          this.close();
        }
      }, () => {
        this.isLoading = false;
      });
  }

  getStores(): void {
    this.commonApiService.getStores().subscribe(
      (response) => {
        this.stores = response;
      });
  }
}
